// Cookie consent helpers — GDPR/TTDSG aware
// Categories:
//  - necessary: always granted (cannot be disabled)
//  - maps: Google Maps embed (third-party)

const STORAGE_KEY = "fivestar-cookie-consent";

export const DEFAULT_CONSENT = {
  necessary: true,
  maps: false,
  ts: null,
  version: 1,
};

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch {
    return null;
  }
}

export function setConsent(partial) {
  const next = {
    ...DEFAULT_CONSENT,
    ...(getConsent() || {}),
    ...partial,
    ts: new Date().toISOString(),
    version: 1,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {}
  // Broadcast change so all components can react (Maps embed etc.)
  window.dispatchEvent(new CustomEvent("consent-change", { detail: next }));
  return next;
}

export function acceptAll() {
  return setConsent({ necessary: true, maps: true });
}

export function rejectAll() {
  return setConsent({ necessary: true, maps: false });
}

export function isAllowed(category) {
  const c = getConsent();
  if (!c) return false;
  return !!c[category];
}
